export default __webpack_public_path__ + "static/media/The Strangler's Hand.2956198b.jpg";